import { createContext, useContext } from 'react';
const CustomSelectContext = createContext({});
export const useCustomSelect = () => useContext(CustomSelectContext);
export const CustomSelectProvider = CustomSelectContext.Provider;
//# sourceMappingURL=useCustomSelect.js.map